import { API_BASE } from '../lib/apiOrigin';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "../i18n/LanguageContext";

const API = API_BASE;
const KEYS = ["awards_main", "awards_2023", "awards_2024", "awards_2025"];

// Only owner-configured images are public. Empty slots never imply an award.
export default function Awards() {
  const { lang } = useLang();
  const [images, setImages] = useState({});
  useEffect(() => {
    let active = true;
    axios.get(`${API}/settings/images`).then(({ data }) => {
      if (active) setImages(data && typeof data === "object" && !Array.isArray(data) ? data : {});
    }).catch(() => { if (active) setImages({}); });
    return () => { active = false; };
  }, []);
  const configured = KEYS.filter(key => typeof images[key] === "string" && images[key].trim());
  if (!configured.length) return null;
  const title = lang === "pt" ? "Reconhecimentos" : lang === "es" ? "Reconocimientos" : "Recognition";
  return <section id="awards" data-testid="awards-section" className="relative py-16 sm:py-24 awards-bg">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <h2 className="font-display font-black text-white text-3xl sm:text-5xl text-center mb-10">{title}</h2>
      <div className="grid grid-cols-3 items-start gap-3 sm:gap-6">
        {configured.map(key => <figure key={key} className={key === "awards_main" ? "col-span-3 mx-auto mb-3 w-full max-w-3xl" : "min-w-0"}>
          <img src={images[key]} alt={key === "awards_main" ? title : `${title} ${key.slice(-4)}`} loading="lazy" className={key === "awards_main" ? "mx-auto max-h-[430px] w-full object-contain" : "mx-auto max-h-72 w-full object-contain"} />
        </figure>)}
      </div>
    </div>
  </section>;
}
